export default __webpack_public_path__ + "KaTeX_Caligraphic-Regular.4a559f36cc9a9ff50a2a5d8f8c7e5d07.woff";